import { render, staticRenderFns } from "./preloader.vue?vue&type=template&id=a066fd22&"
import script from "./preloader.vue?vue&type=script&lang=js&"
export * from "./preloader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\CA5\\PhpstormProjects\\te-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('a066fd22', component.options)
    } else {
      api.reload('a066fd22', component.options)
    }
    module.hot.accept("./preloader.vue?vue&type=template&id=a066fd22&", function () {
      api.rerender('a066fd22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/preloader.vue"
export default component.exports